import React, { useEffect, useState } from "react";
import { useIsFocused, useNavigation, useRoute } from "@react-navigation/native";
import i18n from "utils/i18n";
import _ from "lodash";
import Form from "components/molecules/Form";
import { FormFieldsConstants, FormStatus } from 'utils/constants/form-constants';
import GraphqlBuilder from "utils/request/graphql/builder";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import ThemedBlock from "components/atoms/ThemedBlock";
import LoadingComponent from "components/atoms/Loading";
import Translate from "utils/translate";
import HelperString from 'utils/helper-string'
import ObjectBuildingContact from 'utils/objects/building-contact'
import QueryManagementBuildingContact from 'graphql/queries/management/QueryManagementBuildingContact'
import MutationManagementBuildingContact from 'graphql/mutations/management/MutationManagementBuildingContact'
import { AppRoutes } from 'navigations/app-routes'

const ManagementBuildingContactScene = () => {
	
	const isFocused = useIsFocused();
	const navigation = useNavigation();
	const route = useRoute();
	
	const [ loading, setLoading ] = useState( true )
	const [ contact, setContact ] = useState( {} )
	
	const buildingGuid = _.get( route.params, 'buildingGuid', null )
	const contactGuid = _.get( route.params, 'contactGuid', null )
	
	const fetchContact = () => {
		if( contactGuid !== null ) {
			new GraphqlBuilder()
				.addQuery( 'query', QueryManagementBuildingContact, {
					guid: contactGuid
				})
				.setResultPath( ['query', 'building_contact'], {} )
				.setOnSuccess( result => {
					setLoading( false )
					setContact( result )
				})
				.setOnError( setLoading.bind( this, false ) )
				.execute()
			
			return;
		}
		
		setLoading( false )
		setContact( ObjectBuildingContact.defaults )
	}
	
	const saveForm = ( values, { callback } = {} ) => {
		values[ 'building_guid' ] = buildingGuid;
		
		new GraphqlBuilder()
			.addQuery( 'mutation', MutationManagementBuildingContact, values )
			.setResultPath( ['mutation', 'building_contact'], {} )
			.setOnStart( () => {
				callback( FormStatus.LOADING )
			})
			.setOnSuccess( ( result ) => {
				callback( FormStatus.SUCCESS )
				
				navigation.replace( AppRoutes.MANAGEMENT_BUILDINGS_CONTACT, {
					buildingGuid: buildingGuid,
					contactGuid: result.guid
				});
			})
			.setOnError( ( result ) => {
				callback( FormStatus.ERROR )
			})
			.execute()
	}
	
	useEffect( () => {
		return fetchContact();
	}, [ isFocused, contactGuid ])
	
	let content = <LoadingComponent />
	if( !loading ) {
		
		const formFields = [
			{
				name: 'name',
				label: i18n.t('management:form.name.title'),
				type: FormFieldsConstants.TEXT,
			},
			{
				name: 'email',
				label: i18n.t('management:form.email.title'),
				type: FormFieldsConstants.TEXT_EMAIL,
			},
			{
				name: 'active',
				label: i18n.t('management:form.active.title'),
				type: FormFieldsConstants.SELECT_ACTIVE
			}
		]
		
		content = (
			<ThemedBlock
				header={ i18n.t('management:form_block.title_default') }
				shadow
				mediumPadding>
				
				{/* Default form */}
				<Form
					key={ HelperString.hash( 'form', contact ) }
					values={ contact }
					fields={ formFields }
					onSubmit={ saveForm }
				/>
			</ThemedBlock>
		)
	}
	
	return (
		<ThemedSafeAreaComponentTop
			top={ false }>
			
			<ThemedLayout
				topNavigation={true}
				topNavigationProps={{
					showBackButton: true
				}}
				title={ i18n.t('management:pages.buildings.contact.title', {
					name: Translate.field( contact, 'name' ),
					interpolation: {
						escapeValue: false
					}
				})}>
				
				{ content }
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	);
}

export default ManagementBuildingContactScene
